export default __webpack_public_path__ + "locales/ar-SA/ChangeUserTypeDialog.json?hash=f63e0d525f782e492bff9610177cfbbb";